import { makeStyles } from "@material-ui/core/styles";

export const useToolStyles = makeStyles({
  page: {
    backgroundColor: "#f7f9fc",
    minHeight: "calc(100vh - 64px)",
    paddingTop: "24px",
    paddingBottom: "24px",
  },
  title: { fontSize: "28px", fontWeight: 700, color: "#101828" },
  subtitle: {
    marginTop: "4px",
    marginBottom: "16px",
    fontSize: "14px",
    color: "#475467",
    maxWidth: "760px",
  },
  section: { padding: "20px", marginBottom: "20px" },
  sectionTitle: { fontSize: "20px", fontWeight: 700, color: "#101828" },
  sectionText: {
    marginTop: "4px",
    marginBottom: "16px",
    fontSize: "14px",
    color: "#475467",
    maxWidth: "860px",
  },
  actions: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    alignItems: "center",
    marginBottom: "16px",
  },
  idField: { width: "160px" },
  touch: { minHeight: "40px" },
  cell: { padding: "8px", fontSize: "13px", verticalAlign: "top" },
  headerCell: {
    padding: "8px",
    fontSize: "12px",
    fontWeight: 700,
    backgroundColor: "#f2f5fa",
  },
  number: { textAlign: "right", fontVariantNumeric: "tabular-nums" },
  muted: { color: "#667085", fontSize: "13px" },
  summary: {
    padding: "12px 16px",
    marginBottom: "12px",
    backgroundColor: "#f2f5fa",
    borderRadius: "8px",
    fontSize: "14px",
  },
  dialogText: { fontSize: "14px", color: "#344054", marginBottom: "16px" },
  dialogActions: { display: "flex", justifyContent: "flex-end", gap: "12px" },
  progress: { marginTop: "8px", marginBottom: "8px" },
});

/** "2026-10-05T08:55:32.04" -> "2026-10-05 08:55". */
export const formatDateTime = (value) =>
  value ? String(value).replace("T", " ").slice(0, 16) : "—";
